// eslint-disable-next-line no-redeclare,import/export
export enum SortOrder {
  MOST_RECENT_ACTIVITY = 'most_recent_activity',
  OLDEST_ACTIVITY = 'oldest_activity',
  LONGEST_WAIT_TIME = 'longest_wait_time',
}

const values = Object.values(SortOrder);

// eslint-disable-next-line no-redeclare,import/export
export namespace SortOrder {
  export function mapValues(callbackFn: Parameters<Array<SortOrder>['map']>[0]) {
    return values.map(callbackFn);
  }

  export const human = Object.freeze({
    [SortOrder.MOST_RECENT_ACTIVITY]: 'Most Recent Activity',
    [SortOrder.OLDEST_ACTIVITY]: 'Oldest Activity',
    [SortOrder.LONGEST_WAIT_TIME]: 'Longest Wait Time',
  });
}
